"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useProps } from "@mantine/core";
import { Notifications as MantineNotifications, notifications as mantineNotifications, } from "@mantine/notifications";
import "@mantine/core/styles/Notification.layer.css";
import "@mantine/notifications/styles.layer.css";
import * as notificationStyles from "./Notification.module.css";
const Notifications = (props) => {
    const modifiedProps = useProps("Notification", {
        position: "top-right",
        zIndex: 1000,
    }, props);
    return _jsx(MantineNotifications, { ...modifiedProps });
};
const applyDefaults = (data) => ({
    ...data,
    classNames: {
        ...notificationStyles,
        ...data.classNames,
    },
    withBorder: data.withBorder ?? true,
    radius: data.radius ?? "md",
});
const show = (data, store) => mantineNotifications.show(applyDefaults(data), store);
const update = (data, store) => mantineNotifications.show(applyDefaults(data), store);
const notifications = {
    ...mantineNotifications,
    show,
    update,
};
export { Notifications, notifications };
export { cleanNotifications, cleanNotificationsQueue, hideNotification, createNotificationsStore, notificationsStore, showNotification, updateNotificationsState, useNotifications, } from "@mantine/notifications";
//# sourceMappingURL=Notification.js.map